<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>权限管理</el-breadcrumb-item>
      <el-breadcrumb-item>权限树</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="width: 100%; text-align: center">
      <span>类型选择: </span>
      <el-select @change="getPower()" v-model="type" placeholder="请选择">
        <el-option
          v-for="(item, index) in optionsList"
          :key="index"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
    </div>
    <div style="display: flex">
      <div style="flex: 1">
        <div style="font-size: 20px">
          <span>权限类型</span>
          <el-button type="primary" size="mini" @click="addType()"
            >添加类型</el-button
          >
        </div>
        <div>
          <el-table :data="typeList" style="width: 100%">
            <el-table-column prop="id" label="ID" width="80"> </el-table-column>
            <el-table-column prop="name" label="名称" width="150">
            </el-table-column>
            <el-table-column prop="type" label="类型" width="150">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button size="mini" @click="handleEdit(scope.row)"
                  >编辑</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div style="flex: 2; margin: 10px">
        <div style="font-size: 20px">
          <span>权限树</span>
          <el-button type="primary" size="mini" @click="addItem()"
            >添加根权限</el-button
          >
        </div>

        <el-tree
          :data="powerList"
          node-key="id"
          default-expand-all
          :props="defaultProps"
          :expand-on-click-node="false"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span style="margin-left: 20px">
              <el-button type="text" size="mini" @click="addItem(data)">
                添加
              </el-button>
              <el-button type="text" size="mini" @click="editItem(data)">
                编辑
              </el-button>
              <el-button type="text" size="mini" @click="removeRightById(data)">
                删除
              </el-button>
            </span>
          </span>
        </el-tree>
      </div>
    </div>

    <el-dialog title="添加" :visible.sync="addShow" @close="offDialog">
      <!-- :rules="rules" ref="form" -->
      <el-form :model="addForm" label-width="80px" ref="form">
        <el-form-item label="权限名称" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="权限简介" prop="descr">
          <el-input v-model="addForm.descr" type="textarea"></el-input>
        </el-form-item>

        <el-form-item label="排序" prop="seq">
          <el-input v-model="addForm.seq" placeholder="越小越靠前"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="image_url">
          <div style="display: flex">
            <div v-show="poto == false">
              <el-upload
                class="upload-demo"
                drag
                ref="upload"
                :action="domain"
                :data="QiNiYunL"
                :on-preview="beforeAvatarUpload"
                :on-success="UploadQiNiu"
                multiple
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </div>
            <div v-show="poto == true">
              <el-image
                :src="addForm.image_url"
                style="width: 50%; height: 50%; padding: 20px"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="收费金额" prop="amount">
          <el-input v-model="addForm.amount"></el-input>
        </el-form-item>
        <el-form-item label="路由地址" prop="routeUrl">
          <el-input v-model="addForm.routeUrl"></el-input>
        </el-form-item>
        <el-form-item label="是否按钮">
          <el-switch
            v-model="addForm.is_button"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitAddForm('form')"
            >立即添加</el-button
          >
          <el-button @click="addShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="修改" :visible.sync="editShow">
      <!-- :rules="rules" ref="form" -->
      <el-form :model="editForm" label-width="80px" ref="form">
        <el-form-item label="权限名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="权限简介" prop="descr">
          <el-input v-model="editForm.descr" type="textarea"></el-input>
        </el-form-item>

        <el-form-item label="排序" prop="seq">
          <el-input v-model="editForm.seq" placeholder="越小越靠前"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="image_url">
          <div style="display: flex">
            <div v-show="poto == false">
              <el-upload
                class="upload-demo"
                drag
                ref="upload"
                :action="domain"
                :data="QiNiYunL"
                :on-preview="beforeAvatarUpload"
                :on-success="UploadQiNiu"
                multiple
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  将文件拖到此处，或<em>点击上传</em>
                </div>
              </el-upload>
            </div>
            <div v-show="poto == true">
              <el-image
                :src="editForm.image_url"
                style="width: 50%; height: 50%; padding: 20px"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="收费金额" prop="amount">
          <el-input v-model="editForm.amount"></el-input>
        </el-form-item>
        <el-form-item label="路由地址" prop="routeUrl">
          <el-input v-model="editForm.routeUrl"></el-input>
        </el-form-item>
        <el-form-item label="是否按钮">
          <el-switch
            v-model="addForm.is_button"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitEditForm('form')"
            >立即修改</el-button
          >
          <el-button @click="editShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="添加类型" :visible.sync="typeShow" @close="offDialog">
      <el-form :model="addTypeForm" label-width="80px" ref="form">
        <el-form-item label="名称" prop="name">
          <el-input v-model="addTypeForm.name"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-input v-model="addTypeForm.type"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitAddTypeForm('form')"
            >立即添加</el-button
          >
          <el-button @click="addShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="修改类型" :visible.sync="typeEtitShow" @close="offDialog">
      <el-form :model="editTypeForm" label-width="80px" ref="form">
        <el-form-item label="名称" prop="name">
          <el-input v-model="editTypeForm.name"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-input v-model="editTypeForm.type"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitEditTypeForm('form')"
            >立即修改</el-button
          >
          <el-button @click="addShow = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "power",
  data() {
    return {
      powerList: [],
      typeList: [],
      addShow: false,
      editShow: false,
      typeShow: false,
      typeEtitShow: false,
      poto: false,
      type: "pc",
      domain: "http://up-z0.qiniup.com", //七牛云
      upload_qiniu_addr: "http://img.curiousmore.com/", //显示
      QiNiYunL: {
        key: "",
        token: "",
      },
      // 选择列表
      optionsList: [],
      defaultProps: {
        children: "childrens",
        label: "name",
      },
      addForm: {
        name: "",
        parent_id: "",
        image_url: "",
        type: "",
        is_button: true,
      },
      editForm: {
        id: "",
        name: "",
        descr: "",
        seq: "",
        image_url: "",
        amount: 0,
        routeUrl: "",
        is_button: true,
      },
      addTypeForm: {},
      editTypeForm: {
        type: "",
        name: "",
        id: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          // { min: 3, message: "长度在 3 个字符以上", trigger: "blur" },
        ],
        type: [
          { required: true, message: "请输入类别", trigger: "blur" },
          // { min: 3, message: "长度在 3 个字符以上", trigger: "blur" },
        ],
      },
    };
  },
  mounted: function () {
    this.getcaidan();
    this.getPower();
    this.gettoken(); // 请求token
    this.getType();
  },
  methods: {
    getType() {
      this.$fetch("/authorization/menu/queryManagerListPage?status=3").then(
        (res) => {
          this.typeList = res.data.rows;
          console.log("权限目录x", this.typeList);
        }
      );
    },

    beforeAvatarUpload(file) {
      console.log(111);
      this.$refs.upload.clearFiles();
    },
    getcaidan() {
      this.$fetch("/authorization/menu/queryMenuType").then((res) => {
        this.optionsList = res.data;
        console.log("权限目录", this.optionsList);
      });
    },
    // 关闭弹窗
    offDialog() {
      this.poto = false;
      this.addForm = {};
      this.editForm = {};
    },
    getPower() {
      this.$fetch("/authorization/menu/queryMenuList?type=" + this.type).then(
        (res) => {
          this.powerList = res.data;
          console.log("权限树", this.powerList);
        }
      );
    },
    handleCheckChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
    },

    // ----------类别---------
    addType() {
      this.typeShow = true;
      this.addTypeForm.parent_id = 0;
      this.addTypeForm.status = 3;
      this.addTypeForm.seq = 0;
    },
    handleEdit(row) {
      this.editTypeForm.type = row.type;
      this.editTypeForm.name = row.name;
      this.editTypeForm.id = row.id;
      this.typeEtitShow = true;
    },
    submitAddTypeForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$post("/authorization/menu/insert", this.addTypeForm).then(
            (res) => {
              console.log(res);
              if (res.code == 0) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.getType();
                this.getcaidan();
                this.typeShow = false;
                this.addTypeForm = {};
              } else {
                this.$message({
                  message: res.message,
                });
              }
            }
          );
        } else {
          this.$message({
            message: "表单验证失败",
            type: "warning",
          });
          return false;
        }
      });
    },
    submitEditTypeForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$post("/authorization/menu/update", this.editTypeForm).then(
            (res) => {
              console.log(res);
              if (res.code == 0) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.getType();
                this.getcaidan();
                this.typeEtitShow = false;
              } else {
                this.$message({
                  message: res.message,
                });
              }
            }
          );
        } else {
          this.$message({
            message: "表单验证失败",
            type: "warning",
          });
          return false;
        }
      });
    },
    handleDelete(role) {
      let data = {};
      data.id = role.id;
      data.status = 1;
      this.$confirm("此操作将永久删除该类型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$post("/authorization/menu/update", data).then((res) => {
            if (res.code != 0) {
              this.$message({
                message: res.message,
                type: "error",
              });
            } else {
              this.getType();
              this.getcaidan();
              this.$message({
                message: res.message,
                type: "success",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // ----------end---------

    // ----------权利树---------
    addItem(item) {
      console.log(item);
      if (item == undefined) {
        this.addForm.parent_id = 0;
      } else {
        this.addForm.parent_id = item.id;
      }
      this.addForm.add_user = localStorage.getItem("managerInfo");
      this.addForm.type = this.type;
      this.addForm.is_button = true;
      this.addShow = true;
    },
    editItem(item) {
      console.log(item);
      this.editForm.id = item.id;
      this.editForm.name = item.name;
      this.editForm.descr = item.descr;
      this.editForm.seq = item.seq;
      this.editForm.image_url = item.image_url;
      this.editForm.amount = item.amount;
      this.editForm.routeUrl = item.routeUrl;
      item.is_button == null
        ? (this.editForm.is_button = false)
        : (this.editForm.is_button = item.is_button);
      this.editShow = true;
    },
    submitAddForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$post("/authorization/menu/insert", this.addForm).then((res) => {
            console.log(res);
            if (res.code == 0) {
              this.$message({
                message: "添加成功",
                type: "success",
              });
              this.getPower();
              this.addShow = false;
            } else {
              this.$message({
                message: res.message,
              });
            }
          });
        } else {
          this.$message({
            message: "表单验证失败",
            type: "warning",
          });
          return false;
        }
      });
    },
    submitEditForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$post("/authorization/menu/update", this.editForm).then(
            (res) => {
              console.log(res);
              if (res.code == 0) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.getPower();
                this.editShow = false;
              } else {
                this.$message({
                  message: res.message,
                });
              }
            }
          );
        } else {
          this.$message({
            message: "表单验证失败",
            type: "warning",
          });
          return false;
        }
      });
    },
    removeRightById(role) {
      // 弹框询问用户是否直接删除数据
      let data = {};
      data.id = role.id;
      data.parent_id = role.parent_id;
      data.status = 1;
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$post("/authorization/menu/update", data).then((res) => {
            if (res.code != 0) {
              this.$message({
                message: res.message,
                type: "error",
              });
            } else {
              this.getPower();
              this.$message({
                message: res.message,
                type: "success",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // ----------end---------
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 获取token
    gettoken() {
      var timestamp = new Date().getTime();
      let date = {
        key: timestamp.toString(),
        type: "pic",
      };
      let url = "https://curiousmore.com/qmore/push/upload/getToken";
      this.$post(url, date).then((res) => {
        this.QiNiYunL.token = res.data;
        this.QiNiYunL.key = date.key;
      });
    },
    UploadQiNiu(file, fileList) {
      let url = this.upload_qiniu_addr + file.key;
      this.gettoken();
      // this.$refs.upload.clearFiles()
      if (this.editShow) {
        this.editForm.image_url = url;
      }
      if (this.addShow) {
        this.addForm.image_url = url;
      }
      this.poto = true;
      this.$refs.upload.clearFiles();
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/guanli/power.vue